import React from 'react';

import Layout from '../components/Layout';

const AboutPage = () => {
  return <Layout></Layout>;
};

export default AboutPage;
